"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var comments_1 = tslib_1.__importDefault(require("./comments"));
var utilities_1 = require("./utilities");
var appViewContext_1 = tslib_1.__importDefault(require("../../../view/appViewContext"));
var utilities_2 = require("../../../utilities/utilities");
var base_1 = require("./Header/base");
var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));
var polished_1 = require("polished");
var RefreshButton_1 = tslib_1.__importDefault(require("./RefreshButton"));
var SportHeader_1 = tslib_1.__importDefault(require("./SportHeader"));
var StyledRefreshButton = styled_components_1["default"](RefreshButton_1["default"])(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0;\n"], ["\n  margin: ", " 0;\n"])), polished_1.rem(12));
var ErrorWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  color: red;\n  font-size: ", ";\n"], ["\n  text-align: center;\n  color: red;\n  font-size: ", ";\n"])), polished_1.rem(11));
var C = function (_a) {
    var _b;
    var _c = _a.data, data = _c === void 0 ? {} : _c, renderEmpty = _a.renderEmpty;
    var _d = react_1["default"].useContext(appViewContext_1["default"]), appId = _d.appId, appSpace = _d.appSpace, contentDivider = _d.contentDivider;
    var _e = react_1["default"].useState(false), refreshButtonDisabled = _e[0], setRefreshButtonDisabled = _e[1];
    var _f = react_1["default"].useState(''), refreshError = _f[0], setRefreshError = _f[1];
    var _g = react_1["default"].useState(utilities_1.transformData(data)), transformedData = _g[0], setTransformedData = _g[1];
    var _h = react_1["default"].useState(false), shouldAutoUpdate = _h[0], setShouldAutoUpdate = _h[1];
    // prevent double click
    var debounceTimerRef = react_1["default"].useRef();
    var handleRefreshButtonTimeout = react_1["default"].useCallback(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            setRefreshButtonDisabled(true);
            setRefreshError('');
            if (debounceTimerRef.current) {
                window.clearTimeout(debounceTimerRef.current);
            }
            debounceTimerRef.current = window.setTimeout(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var result, e_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, 4, 5]);
                            if (!(utilities_2.isBrowser() && data && data.url)) return [3 /*break*/, 2];
                            return [4 /*yield*/, utilities_1.fetchOnlajnyEuData(appId, appSpace, contentDivider, data.url)];
                        case 1:
                            result = _a.sent();
                            if ((result === null || result === void 0 ? void 0 : result.content) && (result === null || result === void 0 ? void 0 : result.content[0])) {
                                setTransformedData(utilities_1.transformData(result === null || result === void 0 ? void 0 : result.content[0]));
                            }
                            _a.label = 2;
                        case 2: return [3 /*break*/, 5];
                        case 3:
                            e_1 = _a.sent();
                            setRefreshError(utilities_2.__('Obnova dát skončila s chybou!'));
                            console.error("Error updating onlajny.eu data: " + data.url);
                            console.error(e_1);
                            return [3 /*break*/, 5];
                        case 4:
                            setRefreshButtonDisabled(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); }, 250);
            return [2 /*return*/];
        });
    }); }, []);
    react_1["default"].useEffect(function () {
        setShouldAutoUpdate(utilities_1.shouldRunAutoUpdate(transformedData));
    }, [transformedData]);
    react_1["default"].useEffect(function () {
        var handleVisibilityChange = function () {
            if (document && shouldAutoUpdate) {
                if (document.hidden) {
                    setRefreshButtonDisabled(true);
                }
                else {
                    setRefreshButtonDisabled(false);
                    handleRefreshButtonTimeout();
                }
            }
        };
        if (document) {
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }
        return function () {
            if (document) {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        };
    }, [setRefreshButtonDisabled, handleRefreshButtonTimeout, shouldAutoUpdate]);
    if (!data.data && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('onlajny.eu'));
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null, transformedData ? (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(SportHeader_1["default"], { transformedData: transformedData }),
        react_1["default"].createElement(base_1.Header, null, utilities_2.__('Prenos')),
        shouldAutoUpdate && (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(StyledRefreshButton, { interval: utilities_1.REFRESH_INTERVAL, onTimeout: handleRefreshButtonTimeout, disabled: refreshButtonDisabled }),
            refreshError && react_1["default"].createElement(ErrorWrapper, null, refreshError))),
        react_1["default"].createElement(comments_1["default"], { comments: (_b = transformedData.comments) !== null && _b !== void 0 ? _b : [], sport: transformedData.sport }))) : null));
};
exports["default"] = react_1["default"].memo(C);
var templateObject_1, templateObject_2;
